import { render } from "./UsernameChip.vue?vue&type=template&id=d5008ad0"
import script from "./UsernameChip.vue?vue&type=script&lang=js"
export * from "./UsernameChip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__